import { useCallback, useMemo, useState } from "react"
import { graphql } from "../../../gql"
import CustomTable from "../../Common/CustomTable/CustomTable"
import Loader from "../../Common/Loader/Loader"
import {
  ActionTransaction,
  CraftmanWallet,
  SortOrder,
  WalletType,
} from "../../../gql/graphql"
import { MRT_ColumnDef } from "material-react-table"
import { Pagination } from "../../../types/Pagination"
import { useMutation, useQuery } from "@apollo/client"
import moment from "moment"
import { Box, Button, Tooltip } from "@mui/material"
import { useAppDispatch } from "../../../store/app/hooks"
import {
  setCloseAlert,
  setLoadingDelete,
  setOpenAlert,
} from "../../../store/features/alert/alertSlice"
import { setOpenSnackbar } from "../../../store/features/snackbar/snackbarSlice"
import { getErrorsAsString } from "../../../utils/getErrorsAsString"
import { getUserCountryId } from "../../../utils/authToken"
import { whereInputClause } from "../../../utils/permissions"
import useLang from "../../../hooks/useLang"
import ModalDetailCraftman from "../../Craftman/ModalDetailCraftman/ModalDetailCraftman"

export const CRAFTMANWALLETS = graphql(`
  query CraftmanWallets(
    $where: CraftmanWalletWhereInput
    $orderBy: [CraftmanWalletOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
    $aggregateCraftmanWalletWhere2: CraftmanWalletWhereInput
  ) {
    craftmanWallets(
      where: $where
      orderBy: $orderBy
      take: $take
      skip: $skip
    ) {
      id
      craftmanId
      operator
      orderId
      createdAt
      price
      phoneNumber
      rib
      walletType
      accountNumber
      username
      action
      description
      Craftman {
        id
        country {
          id
          currency
        }
      }
    }
    aggregateCraftmanWallet(where: $aggregateCraftmanWalletWhere2) {
      _count {
        _all
      }
    }
  }
`)

const VALIDATE_CRAFTMAN_PAIMENT = graphql(`
  mutation ValidCraftmanPaiment($paimentId: Float!, $craftmanId: Float!) {
    validCraftmanPaiment(paimentId: $paimentId, craftmanId: $craftmanId) {
      id
    }
  }
`)

const ListAskVersment = () => {
  const countryId = getUserCountryId()
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    size: 10,
  })
  const [query, setQuery] = useState("")
  const dispatch = useAppDispatch()
  const { getText } = useLang()
  const [craftmanId, setCraftmanId] = useState(0)
  const [openDetailCraftman, setOpenDetailCraftman] = useState(false)

  const queryName = useCallback(() => {
    return query
      ? {
          AND: [
            {
              action: {
                in: [ActionTransaction.Asking, ActionTransaction.Debit],
              },
            },
            {
              OR: [
                {
                  Craftman: {
                    is: {
                      OR: [
                        {
                          id: {
                            equals: Number(query),
                          },
                        },
                        {
                          lastName: {
                            search: query,
                          },
                        },
                        {
                          workshopName: {
                            search: query,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  id: {
                    equals: Number(query),
                  },
                },
                {
                  Order: {
                    is: {
                      OR: [
                        {
                          id: {
                            equals: Number(query),
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
        }
      : {
          action: {
            in: [ActionTransaction.Asking, ActionTransaction.Debit],
          },
        }
  }, [query])

  const { loading, data, refetch } = useQuery(CRAFTMANWALLETS, {
    variables: {
      take: pagination.size,
      skip: pagination.page * pagination.size,
      orderBy: { createdAt: SortOrder.Desc },
      where: {
        ...queryName(),
        ...whereInputClause({
          Craftman: {
            is: {
              country: {
                is: {
                  id: {
                    equals: countryId,
                  },
                },
              },
            },
          },
        }),
      },
    },
  })

  const [validatePaimentCraftman] = useMutation(VALIDATE_CRAFTMAN_PAIMENT)

  const style = { backgroundColor: "black", padding: 5 }

  const columns = useMemo<MRT_ColumnDef<CraftmanWallet>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        enableEditing: false,
        size: 80,
        enableClickToCopy: true,
      },
      {
        accessorFn: (row) =>
          row.createdAt
            ? moment(row.createdAt).format("DD MMM YYYY")
            : getText("Pas définie"),
        header: getText("Date de demande"),
        enableClickToCopy: true,
      },
      {
        accessorFn: (row) => (
          <span
            onClick={(e) => {
              e.stopPropagation()
              setCraftmanId(row?.craftmanId || 0)
              setOpenDetailCraftman(true)
            }}
            style={{
              cursor: "pointer",
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            {row.craftmanId || getText("Pas definie")}
          </span>
        ),
        header: getText("ID artisan"),
        enableClickToCopy: true,
      },
      {
        accessorKey: "price",
        header: getText("Montant"),
        enableClickToCopy: true,
      },
      {
        accessorKey: "Craftman.country.currency",
        header: getText("Devise"),
        enableClickToCopy: true,
      },
      {
        accessorFn: (row) =>
          row.walletType == WalletType.Bank
            ? getText("Banque")
            : row.walletType == WalletType.Mobile
            ? getText("Mobile money")
            : getText("Paypal"),
        header: getText("Mode de paiment"),
        enableClickToCopy: true,
      },
      {
        accessorFn: (row) =>
          row.walletType == WalletType.Bank ? (
            <div style={{ width: "100%" }}>
              <ul>
                <li>
                  {getText("Numero de compte")}:{" "}
                  <span style={style}>{row.accountNumber}</span>
                </li>
                <li>
                  {getText("RIB")}: <span style={style}>{row.rib}</span>
                </li>
              </ul>
            </div>
          ) : row.walletType == WalletType.Mobile ? (
            <div style={{ width: "100%" }}>
              <ul>
                <li>
                  {getText("Numéro de téléphone")}:{" "}
                  <span style={style}>{row.phoneNumber}</span>
                </li>
                <li>
                  {getText("Opérateur")}:{" "}
                  <span style={style}>{row.operator}</span>
                </li>
              </ul>
            </div>
          ) : (
            <div style={{ width: "100%" }}>
              <ul>
                <li>
                  {getText("Pseudo")}: <span style={style}>{row.username}</span>
                </li>
              </ul>
            </div>
          ),
        header: getText("Infomation de dépôt"),
        enableClickToCopy: true,
      },
    ],
    [getText],
  )

  const handleChangePagination = (pagination: Pagination) =>
    setPagination(pagination)

  const onChangeSearchValue = (value: string) => setQuery(value)

  const handleValidate = (craftmanId: number, paimentId: number) => {
    dispatch(setLoadingDelete(true))
    validatePaimentCraftman({
      variables: {
        craftmanId,
        paimentId,
      },
      onCompleted: () => {
        dispatch(
          setOpenSnackbar({
            message: getText("Le versment a été fait avec succès"),
            status: "success",
          }),
        )
        dispatch(setLoadingDelete(false))
        dispatch(setCloseAlert())
      },
      onError: (err) => {
        const message = getErrorsAsString(err)
        dispatch(setCloseAlert())
        dispatch(setOpenSnackbar({ message }))
      },
      update: (cache, { data }) => {
        refetch({
          take: pagination.size,
          skip: pagination.page * pagination.size,
          orderBy: [{ createdAt: SortOrder.Desc }],
          where: {
            ...queryName(),
            ...whereInputClause({
              Craftman: {
                is: {
                  country: {
                    is: {
                      id: {
                        equals: countryId,
                      },
                    },
                  },
                },
              },
            }),
          },
        })
      },
    })
  }

  const handleShow = (craftmanId: number, paimentId: number) => {
    dispatch(
      setOpenAlert({
        handleValid: () => handleValidate(craftmanId, paimentId),
        message: getText(
          "Êtes-vous vraiment sûr de vouloir valider cette de demande de versment ?",
        ),
        isLoading: false,
      }),
    )
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  const onCloseDetailCraftman = useCallback(() => {
    setOpenDetailCraftman(false)
  }, [])

  if (loading && !query) return <Loader />

  return (
    <>
      <CustomTable
        columns={columns}
        data={data?.craftmanWallets || []}
        lableAddNew=""
        isLoading={loading}
        showProgressBars={loading}
        rowCount={data?.aggregateCraftmanWallet._count?._all || 0}
        handleChangePagination={handleChangePagination}
        pageIndex={pagination.page}
        pageSize={pagination.size}
        searchValue={query}
        onChangeSearchValue={onChangeSearchValue}
        handleRefresh={handleRefresh}
        isHaveAction={false}
        isCustomAction={true}
        renderAction={({ row, table }) => (
          <Box sx={{ display: "flex" }}>
            {row.original.action === ActionTransaction.Asking ? (
              <Tooltip title={getText("Valider la demande")}>
                <Button
                  variant="contained"
                  color="success"
                  style={{ background: "green" }}
                  onClick={() =>
                    handleShow(row.original.craftmanId, row.original.id)
                  }
                >
                  {getText("Valider")}
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title={getText("Demande de versement est déjà validé")}>
                <p>{getText("c'est déjà validé")}</p>
              </Tooltip>
            )}
          </Box>
        )}
      />
      <ModalDetailCraftman
        craftmanId={craftmanId}
        onClose={onCloseDetailCraftman}
        open={openDetailCraftman}
      />
    </>
  )
}

export default ListAskVersment
